import { Component, ElementRef, EventEmitter, Input, Output, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { DataTable } from "angular2-datatable";
import { DataService } from "../services/dataService";
import { ModalService } from "../shared/dialog/dialog.service";
import { Alert } from "../shared/modal/alert"
import { ValidationMessage } from "../validation/validationMessage";
import { ValidationMessageType } from "../validation/validationMessageType";


@Component({
    selector: "jax-documenthistorycomponent",
    templateUrl: "./documentHistory.component.html"
})

export class DocumentHistoryComponent implements OnInit  {
    public data;
    public caseNumber: string;
    public sortBy = "UploadedDate";
    public sortOrder = "desc";
    public rowsOnPage = 10;
    private userID: number;
    private currentUser: any;
    public totalRecord = 0;
    public isCompleted = false;
    public errorMessage = "";
    public hasError = false;
    public isDocumentDelete=false;
    private MODAL_ID: string;
    private currentDeleteId =0;
    private currentDeleteDocumentTypeID = 0;
    private uploadedDate: Date;
    @Input() caseId: number;
    @Input() caseDisplayNumber: string;
    @ViewChild(Alert) alert: Alert;

    public validationMessage: ValidationMessage;
    

    public documentHistory: any = {};


    constructor(private dataService: DataService, private router: Router, private modalService: ModalService) {
    }

    public ngOnInit() {
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (this.currentUser) {
            this.userID = this.currentUser.UserId;
            this.isDocumentDelete = this.currentUser.Security.search("vintJAXDocumentDelete") >= 0;
        }
        this.MODAL_ID = "uploaddocument";
        this.isCompleted = false;
        this.errorMessage = "";

        this.getDocumentHistory();
    }

    public getDocumentHistory() {
        this.dataService.get("document/documenthistory?caseId=" + this.caseId + "&userId=" + this.userID).subscribe(
            (resp) => {
                this.data = resp;
                this.isCompleted = true,
                this.totalRecord = this.data.length;
            },
            (error) => {
                this.errorMessage = error.message;
                this.isCompleted = true;
                this.hasError = true;
            }); 
    }

    public onchange(pageEvent:any) {
        this.totalRecord = pageEvent.dataLength;
        this.rowsOnPage > 15 ? this.rowsOnPage = 10 : this.rowsOnPage = this.rowsOnPage;
    }

    public removeItem(documentId: number, documentTypeId: number, uploadedDate: Date) {
        this.isCompleted = false;
        this.hasError = false;
        var isJaxOnlyDocument = false;
        var date = new Date(2025, 3, 30, 23, 59, 59);
        if (documentTypeId === 37232555 && new Date(uploadedDate) > date)     
        {
            isJaxOnlyDocument = true;
        }
        this.dataService.post("document/deletesubmitteddocument?DocumentID=" + documentId + "&userId=" + this.userID + "&isJaxOnlyDocument=" + isJaxOnlyDocument)
            .subscribe((res) => {
                    this.errorMessage = "Document deleted successfully.";
                    let message = new ValidationMessage();
                    message.messageType = ValidationMessageType.Ok;
                    message.message = this.errorMessage;
                    this.validationMessage = message;
                    this.getDocumentHistory();
                },
                (error) => {
                    this.errorMessage = error.message;
                    this.isCompleted = true;
                    this.hasError = true;
                    let message = new ValidationMessage();
                    message.messageType = ValidationMessageType.Error;
                    message.message = this.errorMessage;
                    this.validationMessage = message;
                });
    }

    public canDeleteDocument(uploadedDate, UploadedBy) {
        var currentDate = new Date();
        var duration = ((currentDate.getTime() - new Date(uploadedDate).getTime()) / 60000);
        if ((duration <= 60 && this.currentUser.LoginName == UploadedBy) || this.currentUser.Department == 37189923)
            return true;
        else
            return false;
    }

    public canViewDocument() {
              if (this.currentUser.Security.search("vintJAXDocumentView") >= 0)
                  return true;
              else
                  return false;
    }

    public openPdf(documentId: number,documentName: string,documentTypeID: number, uploadedDate: Date) {
        var isJaxOnlyDocument = false;
        var date = new Date(2025, 3, 30, 23, 59, 59);
        if (documentTypeID === 37232555 && new Date(uploadedDate) > date)     
        {
            isJaxOnlyDocument = true;
        }
        this.dataService.sharedService.openPopupWindow();
        this.dataService.getPdf("document/document?documentID=" + documentId + "&documentName=" + encodeURIComponent(documentName) + "&isJaxOnlyDocument=" + isJaxOnlyDocument)
            .subscribe((res) => {
                    this.dataService.sharedService.displayPdf(res,documentName);
                },
                (error) => {
                    this.errorMessage = error.message;
                    this.isCompleted = true;
                    this.hasError = true;
                    this.dataService.sharedService.closePopupWindow();
                });
    }

    public confirmOpen(pendingDocumentId, documentTypeId, uploadedDate) {
        this.currentDeleteId = pendingDocumentId;
        this.currentDeleteDocumentTypeID = documentTypeId;
        this.uploadedDate = uploadedDate;
        this.alert.cancelButton = true;
        this.alert.okButton = true;
        this.alert.alertTitle = "Delete Notification(s)?";
        this.alert.message = "This will delete your document and cannot be recovered.<br>Do you want to continue? ";
        this.alert.okButtonText = "Yes";
        this.alert.okButtonType = "btn-danger";
        this.alert.cancelButtonText = "No";
        this.alert.open();
    }

    public confirmClose(event) {
        let e = event;
        if (this.currentDeleteId > 0) {
            this.removeItem(this.currentDeleteId, this.currentDeleteDocumentTypeID, this.uploadedDate);
        }
        this.currentDeleteId = 0;
    }
}
